module.exports = __webpack_public_path__ + "static/media/overlay.5d1db17f.png";